import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import ScrollDataTable from "./ScrollDataTable";
import FirstRow from "./FirstRow";
import SecondRow from "./SecondRow";
import ThirdRow from "./ThirdRow";
import FourRow from "./FourRow";
import Navbar from "../../../../Navbar/Navbar";

const HeaderIpad = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { P_error, P_ClearError } = value;
          return (
            <>
              <Navbar />
              <div className="row mt-5">
                <div className="col-lg-12 text-warning col-12 ">
                  <div
                    className="card card-warning "
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <div
                      className=" col-12 card-header p-1 border-bottom border-warning "
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <FirstRow />
                    </div>
                    <div className="card-body">
                      <div className="b--black text-right">
                        {P_error != null && (
                          <button
                            className="btn btn-success text-right"
                            type="button"
                          >
                            {P_error.msg ? P_error.msg : P_error.error[0].msg}
                            <span
                              className="ml-2  border-black"
                              onClick={() => P_ClearError()}
                            >
                              X
                            </span>
                          </button>
                        )}
                      </div>
                      <form>
                        <SecondRow />
                        <ThirdRow />
                        <ScrollDataTable />
                        <FourRow />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default HeaderIpad;
